// import Web3 from 'web3';
// import config from '../../lib/config'

export const getReceipt = async (web3, approveCall) => {
  try {
    
    var receipt = null;
    do {
      receipt = await web3.eth.getTransactionReceipt(approveCall);
      if (receipt == null) {
        await new Promise(resolve => setTimeout(resolve, 1000)); // Wait 1 second before retrying
      }
    } while (receipt == null);    
    

    return receipt;
    //       })
  } catch (err) {
    console.error("getReceipt_error", err);
    return await getReceipt(web3, approveCall)
  }
};
